import { render, staticRenderFns } from "./NewlyAdded.vue?vue&type=template&id=40809dba&scoped=true&"
import script from "./NewlyAdded.vue?vue&type=script&lang=js&"
export * from "./NewlyAdded.vue?vue&type=script&lang=js&"
import style0 from "./NewlyAdded.vue?vue&type=style&index=0&id=40809dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40809dba",
  null
  
)

export default component.exports